import { EventHooks } from '../../../nx-data/src/lib/events/nx-events';

export interface DataLoaderEvents {
  loadEntity: string;
  loadAll: void;
}

export type DataLoaderEventHooks = EventHooks<DataLoaderEvents>;
